"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapDiv = exports.ThumbsUpIcon = exports.Summary = exports.SubTitle = exports.SeeDetails = exports.ScrollWayPoint = exports.MobileImgDiv = exports.MarketingCopy = exports.LoggedOutLink = exports.ListItem = exports.Img = exports.FlexDiv = exports.FirstLook = exports.DetailsWrapper = exports.DetailsLink = exports.DesktopImgDiv = exports.Chevron = exports.CcTitle = exports.CardDetailsBottom = exports.CardBottom = exports.Card = exports.ButtonBottomDiv = exports.BottomLine = exports.BottomDetailsLink = exports.BasedInfoText = exports.Aprs = exports.AprTitle = exports.Apr = exports.ApplyButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var Card = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "Card",
  componentId: "sc-ax477i-0"
})(["padding:16px;"]);
exports.Card = Card;

var FirstLook = _styledComponents["default"].div.withConfig({
  displayName: "FirstLook",
  componentId: "sc-ax477i-1"
})(["@media (", "){display:flex;justify-content:space-between;width:100%;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.FirstLook = FirstLook;

var WrapDiv = _styledComponents["default"].div.withConfig({
  displayName: "WrapDiv",
  componentId: "sc-ax477i-2"
})(["@media (", "){width:100%;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.WrapDiv = WrapDiv;

var ScrollWayPoint = _styledComponents["default"].div.withConfig({
  displayName: "ScrollWayPoint",
  componentId: "sc-ax477i-3"
})(["position:absolute;top:-24px;"]);

exports.ScrollWayPoint = ScrollWayPoint;
var CcTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "CcTitle",
  componentId: "sc-ax477i-4"
})(["margin-right:16px;"]);
exports.CcTitle = CcTitle;

var Summary = _styledComponents["default"].div.withConfig({
  displayName: "Summary",
  componentId: "sc-ax477i-5"
})(["display:flex;max-width:100%;margin-top:14px;justify-content:space-between;@media (", "){align-self:flex-end;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Summary = Summary;

var Aprs = _styledComponents["default"].div.withConfig({
  displayName: "Aprs",
  componentId: "sc-ax477i-6"
})(["display:flex;flex-direction:column;width:50%;@media (", "){flex-direction:row;width:100%;justify-content:space-between;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Aprs = Aprs;

var Apr = _styledComponents["default"].div.withConfig({
  displayName: "Apr",
  componentId: "sc-ax477i-7"
})(["margin-bottom:8px;@media (", "){margin-bottom:0;width:50%;margin-right:8px;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Apr = Apr;
var AprTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "AprTitle",
  componentId: "sc-ax477i-8"
})(["&&{display:inline;}@media (", "){&&{display:block;}}"], _baseReactComponents.theme.forLargerThanPhone);
exports.AprTitle = AprTitle;

var Img = _styledComponents["default"].img.withConfig({
  displayName: "Img",
  componentId: "sc-ax477i-9"
})(["max-width:100%;margin-bottom:14px;@media (", "){max-width:164px;height:auto;margin-bottom:0;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Img = Img;

var MobileImgDiv = _styledComponents["default"].div.withConfig({
  displayName: "MobileImgDiv",
  componentId: "sc-ax477i-10"
})(["width:45%;@media (", "){display:none;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.MobileImgDiv = MobileImgDiv;

var DesktopImgDiv = _styledComponents["default"].div.withConfig({
  displayName: "DesktopImgDiv",
  componentId: "sc-ax477i-11"
})(["display:none;@media (", "){width:auto;display:block;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.DesktopImgDiv = DesktopImgDiv;
var ApplyButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "ApplyButton",
  componentId: "sc-ax477i-12"
})(["width:100%;margin-top:10px;margin-bottom:14px;display:inline-block;@media (", "){width:144px;order:3;margin-bottom:0;margin-top:0;margin-left:16px;}"], _baseReactComponents.theme.forLargerThanPhone);
exports.ApplyButton = ApplyButton;

var CardBottom = _styledComponents["default"].div.withConfig({
  displayName: "CardBottom",
  componentId: "sc-ax477i-13"
})(["display:flex;justify-content:space-between;width:100%;align-items:center;@media (", "){order:1;width:100%;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.CardBottom = CardBottom;

var ButtonBottomDiv = _styledComponents["default"].div.withConfig({
  displayName: "ButtonBottomDiv",
  componentId: "sc-ax477i-14"
})(["display:flex;flex-wrap:wrap;@media (", "){justify-content:space-between;margin-top:24px;align-items:center;width:100%;flex-wrap:nowrap;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.ButtonBottomDiv = ButtonBottomDiv;

var DetailsLink = _styledComponents["default"].div.withConfig({
  displayName: "DetailsLink",
  componentId: "sc-ax477i-15"
})(["display:flex;align-items:center;cursor:pointer;"]);

exports.DetailsLink = DetailsLink;
var SeeDetails = (0, _styledComponents["default"])(_baseReactComponents.Link).withConfig({
  displayName: "SeeDetails",
  componentId: "sc-ax477i-16"
})(["font-size:12px;color:", ";&:hover{color:", ";}@media (", "){font-size:14px;}"], _baseReactComponents.theme.neutral400, _baseReactComponents.theme.neutral400, _baseReactComponents.theme.forLargerThanPhone);
exports.SeeDetails = SeeDetails;

var DetailsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DetailsWrapper",
  componentId: "sc-ax477i-17"
})(["margin-top:14px;"]);

exports.DetailsWrapper = DetailsWrapper;
var SubTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function (props) {
  return {
    size: 'md'
  };
}).withConfig({
  displayName: "SubTitle",
  componentId: "sc-ax477i-18"
})([""]);
exports.SubTitle = SubTitle;

var MarketingCopy = _styledComponents["default"].ul.withConfig({
  displayName: "MarketingCopy",
  componentId: "sc-ax477i-19"
})(["color:", ";padding:0;margin-left:16px;margin-top:8px;@media (", "){margin-bottom:24px;}"], _baseReactComponents.theme.neutral400, _baseReactComponents.theme.forLargerThanPhone);

exports.MarketingCopy = MarketingCopy;

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "ListItem",
  componentId: "sc-ax477i-20"
})(["margin-bottom:8px;"]);

exports.ListItem = ListItem;

var BottomLine = _styledComponents["default"].div.withConfig({
  displayName: "BottomLine",
  componentId: "sc-ax477i-21"
})(["margin-bottom:16px;margin-top:8px;@media (", "){border-left:none;padding-left:0;display:flex;align-items:center;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.BottomLine = BottomLine;

var FlexDiv = _styledComponents["default"].div.withConfig({
  displayName: "FlexDiv",
  componentId: "sc-ax477i-22"
})(["@media (", "){display:flex;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.FlexDiv = FlexDiv;

var CardDetailsBottom = _styledComponents["default"].div.withConfig({
  displayName: "CardDetailsBottom",
  componentId: "sc-ax477i-23"
})(["display:flex;justify-content:flex-end;width:100%;@media (", "){order:1;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.CardDetailsBottom = CardDetailsBottom;
var BottomDetailsLink = (0, _styledComponents["default"])(_baseReactComponents.Link).withConfig({
  displayName: "BottomDetailsLink",
  componentId: "sc-ax477i-24"
})(["display:flex;align-items:center;"]);
exports.BottomDetailsLink = BottomDetailsLink;

var Chevron = _styledComponents["default"].div.withConfig({
  displayName: "Chevron",
  componentId: "sc-ax477i-25"
})(["width:16px;height:16px;display:flex;margin-left:8px;align-items:center;transform:", ";@media (", "){width:24px;height:24px;}"], function (_ref) {
  var shouldShowDetails = _ref.shouldShowDetails;
  return !shouldShowDetails && 'rotate(180deg)';
}, _baseReactComponents.theme.forLargerThanPhone);

exports.Chevron = Chevron;
var BasedInfoText = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "BasedInfoText",
  componentId: "sc-ax477i-26"
})(["margin-bottom:8px;"]);
exports.BasedInfoText = BasedInfoText;
var LoggedOutLink = (0, _styledComponents["default"])(_baseReactComponents.Link).withConfig({
  displayName: "LoggedOutLink",
  componentId: "sc-ax477i-27"
})(["cursor:pointer;"]);
exports.LoggedOutLink = LoggedOutLink;
var ThumbsUpIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "ThumbsUpIcon",
  componentId: "sc-ax477i-28"
})(["display:none;@media (", "){display:inline;padding-right:12px;width:36px;height:36px;}"], _baseReactComponents.theme.forLargerThanPhone);
exports.ThumbsUpIcon = ThumbsUpIcon;
//# sourceMappingURL=styles.js.map